import classNames from 'clsx'
import { bool, node, oneOf, shape, string } from 'prop-types'
import { PureComponent } from 'react'

import { IS_JEST, IS_STORYBOOK } from 'shared/consts/env'
import { adSlotSmall, adSlotWide } from 'shared/propsMocks/adSlots'
import { withI18n } from 'shared/utils/withI18n'
import AdSlotPlaceholder from 'views/components/molecules/AdSlotPlaceholder'
import withDataQA from 'views/enhancers/withDataQA'

import './AdSlot.scss'

class AdSlot extends PureComponent {
  render() {
    const {
      id,
      desktopOnly,
      position,
      positionSmall,
      children,
      hiddenInStorybook,
      wide,
      paddingTop,
      paddingBottom,
      noPadding,
      dataAttributes,
      i18n,
    } = this.props
    const classes = classNames('m-AdSlot u-hidden-if-empty chromatic-ignore', {
      'u-padding-x-large--top': paddingTop,
      'u-padding-x-large--bottom': paddingBottom,
      'u-hidden@small-tiny': desktopOnly,
      [`m-AdSlot--${position}`]: position,
      [`m-AdSlot--${positionSmall}@small-tiny`]: positionSmall,
    })
    const wrapperDataAttributes = {
      ...dataAttributes,
      'data-padding-top': paddingTop,
      'data-padding-bottom': paddingBottom,
      'data-no-padding': noPadding,
    }

    if (IS_STORYBOOK || IS_JEST) {
      if (hiddenInStorybook) {
        return null
      }

      let innerComponent
      if (children) {
        innerComponent = children
      } else if (wide) {
        innerComponent = adSlotWide(i18n._('adslot.wide-banner.title'))
      } else {
        innerComponent = adSlotSmall(i18n._('adslot.small-banner.title'))
      }

      return (
        <div
          {...wrapperDataAttributes}
          id={id}
          className={classes}
          data-test-banner="true"
        >
          {innerComponent}
        </div>
      )
    }

    const placeholderClasses = classNames({
      [`m-AdSlot__placeholder--${position}`]: position,
      [`m-AdSlot__placeholder--${positionSmall}@small-tiny`]: positionSmall,
    })

    return (
      <div id={id} className={classes} {...wrapperDataAttributes}>
        <AdSlotPlaceholder slotId={id} className={placeholderClasses} />
      </div>
    )
  }
}

AdSlot.propTypes = {
  id: string.isRequired,
  desktopOnly: bool,
  position: oneOf(['center', 'right']),
  positionSmall: oneOf(['center', 'right']),
  children: node,
  hiddenInStorybook: bool,
  wide: bool,
  paddingTop: bool,
  paddingBottom: bool,
  noPadding: bool,
  dataAttributes: shape({}),
  i18n: shape({}),
}

AdSlot.defaultProps = {
  desktopOnly: false,
  position: null,
  positionSmall: null,
  children: null,
  hiddenInStorybook: false,
  wide: false,
  paddingTop: false,
  paddingBottom: false,
  noPadding: false,
  dataAttributes: {},
}

export default withI18n()(withDataQA(AdSlot))
